<template>
  <div id="contact-role--form">
    <v-radio-group v-model="role">
      <v-radio label="Buyer" value="BUYER"/>
      <v-radio label="Owner" value="OWNER"/>
    </v-radio-group>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {
    role: {
      get: function get() {
        return this.$store.state?.Appointment?.contactComponentData?.role;
      },
      set: function set(newRole) {
        this.$store.dispatch('Appointment/setContactRole', newRole);
      },
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>


<style lang="scss" scoped>
</style>
